const CONTACTS_ASEGURAME = {
  name: 'Asegurame',
  email: {
    url: 'mailto:info@asegurame.cr',
    label: 'info@asegurame.cr',
  },
  telefono: {
    url: 'https://wa.me/50686473773',
    label: '(5O6) 8647-3773',
  },
  socialNetworks: {
    facebook:
      'https://www.facebook.com/people/Asegurame-Costa-Rica/100094186088673/',
    instagram: 'https://www.instagram.com/asegurame.cr/',
    linkedin: 'https://www.linkedin.com/company/asegurame',
    whatsapp: 'https://wa.me/50686473773',
  },
};

const CONTACTS_LA_CATOLICA = {
  name: 'Hospital Internacional La Católica',
  email: {
    url: '',
    label: '',
  },
  telefono: {
    url: 'https://wa.me/50686473773',
    label: '(5O6) 8647-3773',
  },
  socialNetworks: {
    facebook: 'https://www.facebook.com/HospitalInternacionalLaCatolica',
    instagram: 'https://www.instagram.com/hospital_int_la_catolica/',
    linkedin: 'https://www.linkedin.com/company/hospitallacatolica',
    whatsapp: 'https://wa.me/50686473773',
  },
};

export const CONTACTS_COMPANY = {
  ASEGURAME: { ...CONTACTS_ASEGURAME },
  CATOLICA: { ...CONTACTS_LA_CATOLICA },
};
